class BoxTextTemplateService {

    constructor($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
        this.$q = $q;
        this.$http = $http;
        this.ngAuthSettings = ngAuthSettings;
        this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
    }

    getComponentTextInfo(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/' + this.ngAuthSettings.config.paths.getBoxText + data,
                cache: false
            }).then(function (response) {
                resolve(response.data);
            }, function (reason) {
                reject(reason);
            });
        });
    }
}

BoxTextTemplateService.$inject = ['$q', '$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];

export default BoxTextTemplateService;



// WEBPACK FOOTER //
// ./www/components/box-text-template/box-text-template.service.js